import { Type, EventEmitter } from '@angular/core';

import { Subject, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { TextBoxPropertyEditorComponent } from '../property-editors/text-box-property-editor/text-box-property-editor.component';
import { WidthEditorComponent } from '../property-editors/width-editor/width-editor.component';
import { DropDownPropertyEditorComponent } from '../property-editors/drop-down-property-editor/drop-down-property-editor.component';
import { MultiTextBoxPropertyEditorComponent } from '../property-editors/multi-text-box-property-editor/multi-text-box-property-editor.component';
import { OptionPropertyEditorComponent } from '../property-editors/option-property-editor/option-property-editor.component';
import { CheckBoxPropertyEditorComponent } from '../property-editors/check-box-property-editor/check-box-property-editor.component';

import { PropertyDateFormatType, PropertyTimeFormatType, RegionSelectionType } from '../types/property.types';
import { ControlPropertySpecification } from '../types/specification.types';
import { AssociatedDataEntity } from './specification-helper';
import { DefaultValuePropertyEditorComponent } from '../property-editors/default-value-property-editor/default-value-property-editor.component';
import { CascadePropertyEditorComponent } from '../property-editors/cascade-property-editor/cascade-property-editor.component';
import { SelectConditionPropertyEditorComponent } from '../property-editors/select-condition-property-editor/select-condition-property-editor.component';
import { ShowConditionPropertyEditorComponent } from '../property-editors/show-condition-property-editor/show-condition-property-editor.component';
import { DropDownPropertyEditorSetting } from '../types/property-editor.types';
import { AbstractControl } from '../types/control.types';
import { ControlModelPropertyEnum } from '../types/control-model-property';
import { EntityPropertyEditorComponent } from '../property-editors/entity-property-editor/entity-property-editor.component';
import { entityAttributeChange } from './entity-attribute-helper';

const propertyGroupName: {
  standard: string;
  layout: string;
  style: string;
  entityAttribute: string;
  showSetting: string;
} = {
  standard: 'åºæ¬å±æ§',
  layout: 'å¸å±',
  style: 'å¤è§',
  entityAttribute: 'å®ä½å±æ§',
  showSetting: 'å±ç¤ºè®¾ç½®'
};

export function buildOptionValueControlPropertySpecification(
  dataEntities?: Array<AssociatedDataEntity>
): Array<ControlPropertySpecification> {
  const properties = [
    buildNamePropertySpecification(),
    buildIdPropertySpecification(),
    buildCaptionPropertySpecification(),
    buildDefaultValueMultiPropertySpecification(),
    buildDefaultTriggerCascadePropertySpecification(),
    buildReadonlyPropertySpecification(),
    buildColumnLengthPropertySpecification(),
    buildShowLabelPropertySpecification(),

    buildIsHiddenPropertySpecification(),
    buildClearDataWhenHiddenPropertySpecification(),

    buildIsBroadCastPropertySpecification(),
    buildShowContentAtViewPropertySpecification(),
    buildEnableEditAtViewPropertySpecification(),
    buildCascadeParentNamePropertySpecification(),
    buildClassPropertySpecification()
  ];
  properties.push(...buildEntityPropertySpecification(dataEntities));
  return properties;
}

/**
 * æå»ºå®ä½å±æ§è§æ ¼
 */
export function buildEntityPropertySpecification(
  dataEntities?: Array<AssociatedDataEntity>,
  multiProperty?: any
): Array<ControlPropertySpecification> {
  const dataEntitySettings = {
    valueChanged: new EventEmitter<any>(),
    items: dataEntities,
    displayMember: 'caption',
    valueMember: 'name'
  };
  const dataMemberSettings = {
    dataEntity: {} as AssociatedDataEntity,
    emitOriginData: true,
    valueChanged: new EventEmitter<any>(),
    items: new Array<any>(),
    displayMember: 'caption',
    valueMember: 'name',
    multiProperty: multiProperty,
    init() {
      dataMemberSettings.items.splice(0, dataMemberSettings.items.length);
    }
  };

  dataEntitySettings.valueChanged.subscribe((event: any) => {
    dataMemberSettings.dataEntity = event.value;
    dataMemberSettings.items.splice(0, dataMemberSettings.items.length);
    if (event !== undefined && event.value !== undefined && event.value.properties !== undefined) {
      dataMemberSettings.items.push({ caption: 'è¯·éæ©', name: null });
      // å¦ææ¾ç¤ºçåå®¹æ¯ç©ºï¼é»è®¤ç¨valueå¼
      if (event.value.properties) {
        event.value.properties.forEach((s: any) => {
          if (!s.caption) {
            s.caption = s.name;
          }
          dataMemberSettings.items.push(s);
        });
      }
    }
    entityAttributeChange.next({
      dataEntity: dataMemberSettings.dataEntity,
      entityAttributes: dataMemberSettings.items
    });
  });

  const propertyArr = [
    buildPropertySpecification(
      'å®ä½',
      ControlModelPropertyEnum.AssociatedEntities,
      propertyGroupName.entityAttribute,
      DropDownPropertyEditorComponent,
      dataEntitySettings
    ),
    buildPropertySpecification(
      'å±æ§',
      ControlModelPropertyEnum.AssociatedEntityAttributes,
      propertyGroupName.entityAttribute,
      EntityPropertyEditorComponent,
      dataMemberSettings
    )
  ];
  return propertyArr;
}

/**
 * é»è®¤å¼-åè¡ææ¬
 */
export function buildDefaultValuePropertySpecification(order?: number) {
  return buildPropertySpecification(
    'é»è®¤å¼',
    'value',
    propertyGroupName.standard,
    TextBoxPropertyEditorComponent,
    { maxlength: 500 },
    order
  );
}
/**
 * é»è®¤å¼-å¤è¡ææ¬andæ°æ®æº
 */
export function buildDefaultValueMultiPropertySpecification(order?: number) {
  return buildPropertySpecification(
    'é»è®¤å¼',
    'defaultValue',
    propertyGroupName.standard,
    DefaultValuePropertyEditorComponent,
    {
      maxlength: 500
    },
    order
  );
}
/**
 * éé¡¹
 */
export function buildDataSourcePropertySpecification() {
  return buildPropertySpecification('éé¡¹', 'option', propertyGroupName.standard, OptionPropertyEditorComponent);
}
/**
 * åç´ Id
 */
export function buildIdPropertySpecification() {
  return buildPropertySpecification('åç´ Id', 'id', propertyGroupName.standard, TextBoxPropertyEditorComponent, {
    maxlength: 30,
    reg: /^[A-Za-z]+[A-Za-z0-9]*$/,
    changeType: 'blur'
  });
}
/**
 * åç§°
 */
export function buildNamePropertySpecification() {
  return buildPropertySpecification('åç§°', 'name', propertyGroupName.standard, TextBoxPropertyEditorComponent, {
    maxlength: 50,
    reg: /^[A-Za-z]+[\_A-Za-z0-9]*$/,
    changeType: 'blur'
  });
}

/**
 * æ·»å æé®æå­
 */
export function buildAddButtonTextPropertySpecification() {
  return buildPropertySpecification(
    'æ·»å æé®æå­',
    ControlModelPropertyEnum.AddButtonText,
    propertyGroupName.standard,
    TextBoxPropertyEditorComponent,
    {
      maxlength: 50,
      changeType: 'blur'
    }
  );
}

/**
 * å é¤æé®æå­
 */
export function buildDeleteButtonTextPropertySpecification() {
  return buildPropertySpecification(
    'å é¤æé®æå­',
    ControlModelPropertyEnum.DeleteButtonText,
    propertyGroupName.standard,
    TextBoxPropertyEditorComponent,
    {
      maxlength: 50,
      changeType: 'blur'
    }
  );
}

/**
 * çº§è
 */
export function buildCascadeParentNamePropertySpecification() {
  return buildPropertySpecification(
    'çº§è',
    'cascadeParentName',
    propertyGroupName.standard,
    CascadePropertyEditorComponent
  );
}
/**
 * æ¯å¦éè
 */
export function buildIsHiddenPropertySpecification() {
  return buildPropertySpecification('éè', 'isHidden', propertyGroupName.standard, CheckBoxPropertyEditorComponent);
}

export function buildClearDataWhenHiddenPropertySpecification() {
  return buildPropertySpecification(
    'éèæ¶æ¸ç©ºæ°æ®',
    'clearDataWhenHidden',
    propertyGroupName.standard,
    CheckBoxPropertyEditorComponent
  );
}
/**
 * æ é¢
 */
export function buildCaptionPropertySpecification() {
  return buildPropertySpecification('æ é¢', 'caption', propertyGroupName.standard, TextBoxPropertyEditorComponent, {
    maxlength: 50
  });
}
/**
 * æç¤ºä¿¡æ¯
 */
export function buildPlaceholderPropertySpecification() {
  return buildPropertySpecification(
    'æç¤ºä¿¡æ¯',
    'placeholder',
    propertyGroupName.standard,
    TextBoxPropertyEditorComponent,
    { maxlength: 50 }
  );
}
/**
 * é»è®¤è§¦åçº§è
 */
export function buildDefaultTriggerCascadePropertySpecification() {
  return buildPropertySpecification(
    'é»è®¤è§¦åçº§è',
    'defaultTriggerCascade',
    propertyGroupName.standard,
    CheckBoxPropertyEditorComponent
  );
}
/**
 * åªè¯»
 */
export function buildReadonlyPropertySpecification() {
  return buildPropertySpecification('åªè¯»', 'readonly', propertyGroupName.standard, CheckBoxPropertyEditorComponent);
}
/**
 * æ¾ç¤ºæ é¢
 */
export function buildShowLabelPropertySpecification() {
  return buildPropertySpecification(
    'æ¾ç¤ºæ é¢',
    'showLabel',
    propertyGroupName.standard,
    CheckBoxPropertyEditorComponent
  );
}
/**
 * å¹¿æ­äºä»¶
 */
export function buildIsBroadCastPropertySpecification() {
  return buildPropertySpecification(
    'å¹¿æ­äºä»¶',
    'isBroadCastEvent',
    propertyGroupName.standard,
    CheckBoxPropertyEditorComponent
  );
}
/**
 * 'å®½åº¦(å)
 */
export function buildColumnLengthPropertySpecification(defaultValue?: number) {
  return buildPropertySpecification('å®½åº¦(å)', 'columnLength', propertyGroupName.layout, WidthEditorComponent, {
    defaultValue: defaultValue !== undefined ? defaultValue : 12
  });
}
/**
 * class
 */
export function buildClassPropertySpecification() {
  return buildPropertySpecification('Class', 'class', propertyGroupName.style, TextBoxPropertyEditorComponent, {
    maxlength: 100
  });
}

/**
 * åå®¹
 */
export function buildTextPropertySpecification(maxlength?: number) {
  return buildPropertySpecification('åå®¹', 'text', propertyGroupName.standard, TextBoxPropertyEditorComponent, {
    maxlength: maxlength !== undefined ? maxlength : 50
  });
}
/**
 * åè®¸å¤ä¸ª
 */
export function buildMultiplePropertySpecification(caption?: string) {
  return buildPropertySpecification(
    caption ? caption : 'åè®¸å¤ä¸ª',
    'multiple',
    propertyGroupName.standard,
    CheckBoxPropertyEditorComponent
  );
}

export function buildTemplateHiddenPropertySpecification() {
  return buildPropertySpecification(
    'æ¨¡æ¿éè',
    'templateHidden',
    propertyGroupName.standard,
    CheckBoxPropertyEditorComponent
  );
}
/**
 * ä¸è½½æ¨¡æ¿åç§°
 */
export function buildUploadTemplateNamePropertySpecification(name?: string) {
  return buildPropertySpecification(
    'æ¨¡æ¿åç§°',
    'templateName',
    propertyGroupName.standard,
    TextBoxPropertyEditorComponent,
    {
      maxlength: 50,
      changeType: 'blur'
    }
  );
}
/**
 * ä¸è½½æ¨¡æ¿å°å
 */
export function buildUploadTemplateUrlPropertySpecification(url?: string) {
  return buildPropertySpecification(
    'æ¨¡æ¿å°å',
    'templateUrl',
    propertyGroupName.standard,
    TextBoxPropertyEditorComponent,
    {
      maxlength: 300,
      reg: /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?/,
      changeType: 'blur'
    }
  );
}

/**
 * æ¥çåªæ¾ç¤ºåå®¹
 */
export function buildShowContentAtViewPropertySpecification(caption?: string) {
  return buildPropertySpecification(
    'æ¥çæ¶åªæ¾ç¤ºåå®¹',
    'showContentAtView',
    propertyGroupName.standard,
    CheckBoxPropertyEditorComponent
  );
}

/**
 * å¯ç¨æ¥çæ¶ç¼è¾
 */
export function buildEnableEditAtViewPropertySpecification(caption?: string) {
  return buildPropertySpecification(
    'å¯ç¨æ¥çæ¶ç¼è¾',
    'enableEditAtView',
    propertyGroupName.standard,
    CheckBoxPropertyEditorComponent
  );
}

export function buildMultiTextPropertySpecification() {
  return buildPropertySpecification('é»è®¤å¼', 'text', propertyGroupName.standard, MultiTextBoxPropertyEditorComponent, {
    maxlength: 5000
  });
}
/**
 * æ¥æå±æ§
 */
export function buildDateTimePropertySpecification(order?: number) {
  const dateFormat = {
    valueChanged: new EventEmitter<any>(),
    items: [
      { name: '', caption: 'çç©º' },
      { name: PropertyDateFormatType.yearMonth, caption: 'å¹´-æ' },
      { name: PropertyDateFormatType.yearMonthDay, caption: 'å¹´-æ-æ¥' }
    ],
    displayMember: 'caption',
    valueMember: 'name'
  };

  const timeFormat = {
    valueChanged: new EventEmitter<any>(),
    items: [
      { name: '', caption: 'çç©º' },
      { name: PropertyTimeFormatType.hourMinuteSecond, caption: 'æ¶:å:ç§' },
      { name: PropertyTimeFormatType.hourMinute, caption: 'æ¶:å' }
    ],
    displayMember: 'caption',
    valueMember: 'name',
    init() {}
  };
  const properties = [
    buildPropertySpecification(
      'æ¥ææ ¼å¼',
      'dateFormat',
      propertyGroupName.standard,
      DropDownPropertyEditorComponent,
      dateFormat,
      order
    ),
    buildPropertySpecification(
      'æ¶é´æ ¼å¼',
      'timeFormat',
      propertyGroupName.standard,
      DropDownPropertyEditorComponent,
      timeFormat,
      order
    )
  ];
  return properties;
}
/**
 * ä½ä¸ºæ¥è¯¢æ¡ä»¶
 */
export function buildSelectedConditionPropertySpecification(showTemplateType: boolean = false) {
  return buildPropertySpecification(
    'ä½ä¸ºæ¥è¯¢æ¡ä»¶',
    'selectCondition',
    propertyGroupName.showSetting,
    SelectConditionPropertyEditorComponent,
    {
      showTemplateType: showTemplateType,
      showRule: true,
      min: 1,
      max: 100,
      rules: {
        eq: 'ç­äº',
        ne: 'ä¸ç­äº',
        lt: 'å°äº',
        le: 'å°äºç­äº',
        gt: 'å¤§äº',
        ge: 'å¤§äºç­äº',
        bw: 'å¼å¤´æ¯',
        bn: 'å¼å¤´ä¸æ¯',
        ew: 'ç»å°¾æ¯',
        en: 'ç»å°¾ä¸æ¯',
        cn: 'åå«',
        nc: 'ä¸åå«',
        bt: 'ä»äº'
      },
      entityAttributeChange$: entityAttributeChange.asObservable()
    }
  );
}

/**
 * ä½ä¸ºå±ç¤ºå
 */
export function buildShowConditionPropertySpecification() {
  return buildPropertySpecification(
    'ä½ä¸ºå±ç¤ºå',
    'showCondition',
    propertyGroupName.showSetting,
    ShowConditionPropertyEditorComponent,
    {
      min: 1,
      max: 100,
      entityAttributeChange$: entityAttributeChange.asObservable()
    }
  );
}

/**
 * å­è¡¨åéæ©è¡¨ååæ ç­¾
 *
 */
export function buildSelectFormPropertySpecification(): Array<ControlPropertySpecification> {
  const formSelectSetting: DropDownPropertyEditorSetting<any> = {
    items: [],
    valueChanged: new EventEmitter<any>(),
    getItemsAsync: (designerConfig, httpClient) => {
      return httpClient
        .get<any>(`${designerConfig.serviceUrl}dynamicform/forms/published`)
        .pipe(map((s) => [{ formName: 'è¯·éæ©', formCode: null }, ...s]));
    },
    displayMember: 'formName',
    valueMember: 'formCode'
  };

  const labelCodeSetting: DropDownPropertyEditorSetting<any> = {
    emitOriginData: true,
    valueChanged: new EventEmitter<any>(),
    items: new Array<any>(),
    getItemsAsync: (designerConfig, httpClient, parent) => {
      if (!parent) {
        return of([]);
      }
      return httpClient
        .get<any>(`${designerConfig.serviceUrl}dynamicform/labels`, {
          params: {
            filter: { rules: [{ field: 'formId', op: 'eq', data: parent.value.id }] }
          } as any
        })
        .pipe(
          map((s) => {
            s.data = (s.data as any[]).map((d: any) => {
              d.labelName = d.labelCode;
              return d;
            });
            s.data.unshift({ labelName: 'è¯·éæ©', labelCode: null });
            return s.data;
          })
        );
    },
    parentValueChanged: new Subject<{ target: AbstractControl<any>; value: any }>(),
    displayMember: 'labelName',
    valueMember: 'labelCode',
    init() {
      labelCodeSetting.items.splice(0, labelCodeSetting.items.length);
    }
  };

  formSelectSetting.valueChanged.subscribe((event: { target: AbstractControl<any>; value: any }) => {
    labelCodeSetting.items.splice(0, labelCodeSetting.items.length);
    if (event !== undefined && event.value !== undefined) {
      labelCodeSetting.parentValueChanged.next(event);
    }
  });

  return [
    buildPropertySpecification(
      'è¡¨å',
      'formCode',
      propertyGroupName.standard,
      DropDownPropertyEditorComponent,
      formSelectSetting
    ),
    buildPropertySpecification(
      'è¡¨åæ ç­¾',
      'formLabelCode',
      propertyGroupName.standard,
      DropDownPropertyEditorComponent,
      labelCodeSetting
    )
  ];
}

/**
 * æ¥æå±æ§
 */
export function buildRegionSelectionTypePropertySpecification(order?: number) {
  const selectionType = {
    valueChanged: new EventEmitter<any>(),
    items: [
      {
        // tslint:disable-next-line: no-bitwise
        name: RegionSelectionType.Province | RegionSelectionType.City | RegionSelectionType.District,
        caption: 'ç-å¸-åº'
      },
      // tslint:disable-next-line: no-bitwise
      { name: RegionSelectionType.Province | RegionSelectionType.City, caption: 'ç-å¸' },
      { name: RegionSelectionType.Province, caption: 'ç' }
    ],
    displayMember: 'caption',
    valueMember: 'name'
  };

  const properties = [
    buildPropertySpecification(
      'éæ©ç±»å',
      'selectionType',
      propertyGroupName.standard,
      DropDownPropertyEditorComponent,
      selectionType,
      order
    )
  ];
  return properties;
}

export function buildTextBoxPropertySpecification(
  caption: string,
  propertyName: string,
  editorSettings?: any,
  order?: number
): ControlPropertySpecification {
  return {
    caption: caption,
    propertyName: propertyName,
    groupName: propertyGroupName.standard,
    editorComponent: TextBoxPropertyEditorComponent,
    editorSettings: editorSettings,
    order: order
  };
}

export function buildPropertySpecification(
  caption: string,
  propertyName: string,
  groupName: string,
  editor: Type<any>,
  editorSettings?: any,
  order?: number
): ControlPropertySpecification {
  return {
    caption: caption,
    propertyName: propertyName,
    groupName: groupName,
    editorComponent: editor,
    editorSettings: editorSettings,
    order: order
  };
}
